/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_ParentInputs */

const en_filter_has_parent = /** @type {(inputs: Filter_Has_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a parent`)
};

const de_filter_has_parent = /** @type {(inputs: Filter_Has_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`übergeordneten Vorgang`)
};

/**
* | output |
* | --- |
* | "a parent" |
*
* @param {Filter_Has_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_parent = /** @type {((inputs?: Filter_Has_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_parent(inputs)
	return en_filter_has_parent(inputs)
});